import styles from "./disclaimer.module.css";
import { Award, PersonStanding, Sparkles, Volleyball } from "lucide-react";
import { useTranslation } from "react-i18next";

const Disclaimer = ({ status }) => {
  const { t } = useTranslation();

  const mapping = {
    start: "start",
    soccer: "soccer",
    player: "player",
    captain: "captain",
  };

  const mappingIcon = {
    start: <Sparkles size={12} className={`icon ${styles["start-icon"]}`} />,
    soccer: (
      <Volleyball size={12} className={`icon ${styles["soccer-icon"]}`} />
    ),
    player: (
      <PersonStanding size={12} className={`icon ${styles["player-icon"]}`} />
    ),
    captain: <Award size={12} className={`icon ${styles["captain-icon"]}`} />,
  };

  const defaultStatus = "start";
  const resolvedStatus = mapping[status] ? status : defaultStatus;

  return (
    <div className={`${styles.wrapper} ${styles[mapping[status]]}`}>
      {mappingIcon[status]}
      <p className="title-4">
        {t(`disclaimer.status.${mapping[resolvedStatus]}`)}
      </p>
    </div>
  );
};

export default Disclaimer;
